export default __webpack_public_path__ + "static/cashflow_new_6-00efc06d45e4a23dd7b2036d24918f0c.jpg";